import _ from 'lodash';
import angular from 'angular';
import { Async, Inject } from '../../../base/decorators';
import { BasePopup, BasePopupConfiguration } from '../base-popup/component';

export const DataCache = {};

export class EmployerDetailsPopup extends BasePopup {
    @Inject('EmployerService')
    employerService;

    @Async()
    async loadContent() {
        const { employerId } = this;
        const { result : employer } = await this.employerService.getEmployer(employerId);
        const employerName = employer.name;
        const employerWebsite = _.get(employer, 'contact.webAddress[0].value', '');
        const employerEmail = _.get(employer, 'contact.email[0].value', '');
        const employerPhone1 = _.get(employer, 'contact.phone[0].value', '');
        const employerPhone2 = _.get(employer, 'contact.phone[1].value', '');
        const country = _.get(employer, 'locations[0].country', '');
        const state = _.get(employer, 'locations[0].state', '');
        const city = _.get(employer, 'locations[0].city', '');
        const zipCode = _.get(employer, 'locations[0].zipCode', '');
        const streetAddress = _.get(employer, 'locations[0].streetAddress', '');
        const locationName = _.get(employer, 'locations[0].locationName', '');
        const list = [
            employerWebsite,
            `${locationName} ${country}`,
            `${state} ${city}`,
            `${streetAddress} ${zipCode}`,
            `${employerPhone1}`,
            `${employerPhone2}`,
            `${employerEmail}`
        ].reduce((resultList, message) => {
            if (message) {
                return `${resultList}<div class="job-table-popup--data-item">${message}</div>`;
            }

            return resultList;
        });

        return `<div class="job-table-popup--title">${employerName}</div>
                <div class="job-table-popup--data-items">${list}</div>`;
    }

    getContentFromCache() {
        const { employerId } = this;

        return DataCache[employerId];
    }

    setContentToCache(content) {
        const { employerId } = this;

        DataCache[employerId] = content;
    }
}

export const EmployerDetailsPopupConfiguration = {
    ...BasePopupConfiguration,
    controller: EmployerDetailsPopup,
    bindings: {
        ...BasePopupConfiguration.bindings,
        employerId: '<',
    },
};

angular.module('TALENYA-FE').component('employerDetailsPopup', EmployerDetailsPopupConfiguration);